import { NgModule } from '@angular/core';
import { BudgetDetailBudgetComponent } from './budget/budget-manager/budget-detail-budget/budget-detail-budget.component';
import { BudgetDetailItemComponent } from './budget/budget-manager/budget-detail/budget-detail-item/budget-detail-item.component';
import { BudgetDetailComponent } from './budget/budget-manager/budget-detail/budget-detail.component';
import { BudgetItemManagerComponent } from './budget/budget-manager/budget-item-manager/budget-item-manager.component';
import { BudgetMonthComponent } from './budget/budget-manager/budget-month/budget-month.component';
import { PhotoSwipeComponent } from './common/photo-swipe/photo-swipe.component';
import { BimDetailComponent } from './facility/bim/bim-detail/bim-detail.component';
import { BimEquipmentDetailComponent } from './facility/bim/bim-equipment-detail/bim-equipment-detail.component';
import { BimMaintenaceDetailComponent } from './facility/bim/bim-maintenace-detail/bim-maintenace-detail.component';
import { StateAlarmDetailComponent } from './facility/bim/state-alarm-detail/state-alarm-detail.component';
import { EntryDetailComponent } from './facility/entry-detail/entry-detail.component';
import { EntrySpareComponent } from './facility/entry-spare/entry-spare.component';
import { FacilityDetailComponent } from './facility/facility-manger/facility-detail/facility-detail.component';
import { FacilityGroupEquipmentComponent } from './facility/facility-manger/facility-group-equipment/facility-group-equipment.component';
import { FacilityGroupInfoComponent } from './facility/facility-manger/facility-group-info/facility-group-info.component';
import { FacilityGroupComponent } from './facility/facility-manger/facility-group/facility-group.component';
import { OutDetailComponent } from './facility/out-spare/out-detail/out-detail.component';
import { OutSpareComponent } from './facility/out-spare/out-spare.component';
import { SpareInfoComponent } from './facility/spareparts-management/spare-info/spare-info.component';
import { SpareListComponent } from './facility/spareparts-management/spare-list/spare-list.component';
import { SparepartsManagementComponent } from './facility/spareparts-management/spareparts-management.component';
import { TakeSpareDetailComponent } from './facility/take-spare/take-spare-detail/take-spare-detail.component';
import { TakeSpareComponent } from './facility/take-spare/take-spare.component';
import { HexagonsiOmsLibComponent } from './hexagonsi-oms-lib.component';
import { HistoryReceiveRecordComponent } from './job/job-manager/job-detail/history-receive-record/history-receive-record.component';
import { HistoryRepairRecordDetailComponent } from './job/job-manager/job-detail/history-repair-record-detail/history-repair-record-detail.component';
import { HistoryRepairRecordComponent } from './job/job-manager/job-detail/history-repair-record/history-repair-record.component';
import { JobCostListComponent } from './job/job-manager/job-detail/job-cost-list/job-cost-list.component';
import { JobCostComponent } from './job/job-manager/job-detail/job-cost/job-cost.component';
import { JobDetailFootComponent } from './job/job-manager/job-detail/job-detail-foot/job-detail-foot.component';
import { JobEvaluateComponent } from './job/job-manager/job-detail/job-detail-foot/job-evaluate/job-evaluate.component';
import { JobVerifyComponent } from './job/job-manager/job-detail/job-detail-foot/job-verify/job-verify.component';
import { JobDetailHeaderComponent } from './job/job-manager/job-detail/job-detail-header/job-detail-header.component';
import { JobPatrolSheetComponent } from './job/job-manager/job-detail/job-detail-header/job-patrol-sheet/job-patrol-sheet.component';
import { JobDetailComponent } from './job/job-manager/job-detail/job-detail.component';
import { JobQuotationTableComponent } from './job/job-manager/job-detail/job-quotation-table/job-quotation-table.component';
import { JobQuotationTraceComponent } from './job/job-manager/job-detail/job-quotation-trace/job-quotation-trace.component';
import { JobSignatureComponent } from './job/job-manager/job-detail/job-signature/job-signature.component';
import { JobRepairApplyComponent } from './job/job-manager/job-repair-apply/job-repair-apply.component';
import { JobTraceComponent } from './job/job-trace/job-trace.component';
import { KnowledgeDetailComponent } from './knowledge/knowledge-manager/knowledge-detail/knowledge-detail.component';
import { KnowledgeManagerComponent } from './knowledge/knowledge-manager/knowledge-manager.component';
import { DynamicFormQuestionComponent } from './patrol-template-management/dynamic-form-question/dynamic-form-question.component';
import { PatrolControlDetailComponent } from './patrol-template-management/patrol-control-detail/patrol-control-detail.component';
import { PatrolControlPreviewComponent } from './patrol-template-management/patrol-control-preview/patrol-control-preview.component';
import { PatrolTemplateDetailComponent } from './patrol-template-management/patrol-template-detail/patrol-template-detail.component';
import { PatrolTemplateManagementComponent } from './patrol-template-management/patrol-template-management.component';
import { UploadFileComponent } from './patrol-template-management/upload-file/upload-file.component';
import { ContractEvaluateComponent } from './provider/provider-contract-manager/contract-evaluate/contract-evaluate.component';
import { ContractComponent } from './provider/provider-contract-manager/contract/contract.component';
import { ProviderContractManagerComponent } from './provider/provider-contract-manager/provider-contract-manager.component';
import { ProviderDetailComponent } from './provider/provider-manager/provider-detail/provider-detail.component';
import { ProviderManagerComponent } from './provider/provider-manager/provider-manager.component';
import { ProviderComponent } from './provider/provider-manager/provider/provider.component';
import { ProviderQuotationsheetManagerComponent } from './provider/provider-quotationsheet-manager/provider-quotationsheet-manager.component';
import { QuotationsheetComponent } from './provider/provider-quotationsheet-manager/quotationsheet/quotationsheet.component';
import { ProviderTechnicalAgreementManagerComponent } from './provider/provider-technical-agreement-manager/provider-technical-agreement-manager.component';
import { TechnicalAgreementComponent } from './provider/provider-technical-agreement-manager/technical-agreement/technical-agreement.component';
import { ApplyService } from './service/apply.service';
import { JobParameterService } from './service/common/job-parameter.service';
import { CostService } from './service/cost.service';
import { CustomValidatorService } from './service/custom-validator.service';
import { EquipmentService } from './service/equipment.service';
import { FileManagerService } from './service/file-manager.service';
import { JobQuotationService } from './service/job-quotation.service';
import { JobSignatureService } from './service/job-signature.service';
import { JobService } from './service/job.service';
import { KnowledgeService } from './service/knowledge.service';
import { NotificationDetailService } from './service/notification-detail.service';
import { NotificationService } from './service/notification.service';
import { PatrolAreaService } from './service/patrol-area.service';
import { PatrolGroupService } from './service/patrol-group.service';
import { PatrolSheetService } from './service/patrol-sheet.service';
import { PatrolTemplateService } from './service/patrol-template.service';
import { ProviderService } from './service/provider.service';
import { QuestionService } from './service/question.service';
import { SparepartsService } from './service/spareparts.service';
import { AuthenticationService } from './service/system/authentication.service';
import { ToolService } from './service/tool.service';
import { ShareModule } from './share/share.module';
import { ToolDetailComponent } from './tool/tool-manager/tool-detail/tool-detail.component';
import { ToolManagerComponent } from './tool/tool-manager/tool-manager.component';
import { ToolSearchComponent } from './tool/tool-manager/tool-search/tool-search.component';
import { ToolTableComponent } from './tool/tool-manager/tool-table/tool-table.component';
import { ToolTraceComponent } from './tool/tool-manager/tool-trace/tool-trace.component';



@NgModule({
  declarations: [
    HexagonsiOmsLibComponent,
    PatrolTemplateManagementComponent,
    PatrolTemplateDetailComponent,
    PatrolControlDetailComponent,
    DynamicFormQuestionComponent,
    PatrolControlPreviewComponent,
    UploadFileComponent,
    HistoryReceiveRecordComponent,
    HistoryRepairRecordComponent,
    HistoryRepairRecordDetailComponent,
    JobCostComponent,
    JobCostListComponent,
    JobDetailFootComponent,
    JobDetailHeaderComponent,
    JobQuotationTableComponent,
    JobQuotationTraceComponent,
    JobSignatureComponent,
    JobDetailComponent,
    JobTraceComponent,
    KnowledgeDetailComponent,
    KnowledgeManagerComponent,
    OutDetailComponent,
    OutSpareComponent,
    TakeSpareDetailComponent,
    TakeSpareComponent,
    ToolDetailComponent,
    ToolSearchComponent,
    ToolTableComponent,
    ToolTraceComponent,
    ToolManagerComponent,
    JobEvaluateComponent,
    JobVerifyComponent,
    JobPatrolSheetComponent,
    SpareListComponent,
    SpareInfoComponent,
    FacilityDetailComponent,
    FacilityGroupComponent,
    FacilityGroupEquipmentComponent,
    FacilityGroupInfoComponent,
    BudgetDetailItemComponent,
    BudgetDetailComponent,
    BudgetDetailBudgetComponent,
    BudgetItemManagerComponent,
    BudgetMonthComponent,
    SparepartsManagementComponent,
    EntryDetailComponent,
    EntrySpareComponent,
    PhotoSwipeComponent,
    BimDetailComponent,
    BimEquipmentDetailComponent,
    BimMaintenaceDetailComponent,
    StateAlarmDetailComponent,
    JobRepairApplyComponent,
    ContractComponent,
    ContractEvaluateComponent,
    ProviderContractManagerComponent,
    ProviderComponent,
    ProviderDetailComponent,
    ProviderManagerComponent,
    QuotationsheetComponent,
    ProviderQuotationsheetManagerComponent,
    TechnicalAgreementComponent,
    ProviderTechnicalAgreementManagerComponent
  ],
  imports: [
    ShareModule
  ],
  exports: [
    HexagonsiOmsLibComponent,
    PatrolTemplateManagementComponent,
    PatrolTemplateDetailComponent,
    PatrolControlDetailComponent,
    DynamicFormQuestionComponent,
    PatrolControlPreviewComponent,
    UploadFileComponent,
    HistoryReceiveRecordComponent,
    HistoryRepairRecordComponent,
    HistoryRepairRecordDetailComponent,
    JobCostComponent,
    JobCostListComponent,
    JobDetailFootComponent,
    JobDetailHeaderComponent,
    JobQuotationTableComponent,
    JobQuotationTraceComponent,
    JobSignatureComponent,
    JobDetailComponent,
    JobTraceComponent,
    KnowledgeDetailComponent,
    KnowledgeManagerComponent,
    OutDetailComponent,
    OutSpareComponent,
    TakeSpareDetailComponent,
    TakeSpareComponent,
    ToolDetailComponent,
    ToolSearchComponent,
    ToolTableComponent,
    ToolTraceComponent,
    ToolManagerComponent,
    JobEvaluateComponent,
    JobVerifyComponent,
    JobPatrolSheetComponent,
    SpareListComponent,
    SpareInfoComponent,
    FacilityDetailComponent,
    FacilityGroupComponent,
    FacilityGroupEquipmentComponent,
    FacilityGroupInfoComponent,
    BudgetDetailItemComponent,
    BudgetDetailComponent,
    BudgetDetailBudgetComponent,
    BudgetItemManagerComponent,
    BudgetMonthComponent,
    SparepartsManagementComponent,
    EntryDetailComponent,
    EntrySpareComponent,
    PhotoSwipeComponent,
    BimDetailComponent,
    BimEquipmentDetailComponent,
    BimMaintenaceDetailComponent,
    StateAlarmDetailComponent,
    JobRepairApplyComponent,
    ContractComponent,
    ContractEvaluateComponent,
    ProviderContractManagerComponent,
    ProviderComponent,
    ProviderDetailComponent,
    ProviderManagerComponent,
    QuotationsheetComponent,
    ProviderQuotationsheetManagerComponent,
    TechnicalAgreementComponent,
    ProviderTechnicalAgreementManagerComponent
  ],
  providers: [
    AuthenticationService,
    JobParameterService,
    NotificationDetailService,
    NotificationService,
    PatrolAreaService,
    PatrolGroupService,
    PatrolSheetService,
    QuestionService,
    JobQuotationService,
    JobSignatureService,
    JobService,
    KnowledgeService,
    PatrolTemplateService,
    ProviderService,
    SparepartsService,
    ApplyService,
    CostService,
    CustomValidatorService,
    EquipmentService,
    ToolService,
    FileManagerService
  ]
})
export class HexagonsiOmsLibModule { }
